export default {"src":"/_next/static/media/Dropdown.f084bd58.svg","height":11,"width":11,"blurWidth":0,"blurHeight":0};